/**
 * A styled component for rendering text with optional truncation.
 *
 * @typedef {Object} TextProps
 * @property {boolean} [truncate] - Whether to truncate the text
 * @property {number} [lineClamp=1] - The number of lines to display before truncating if truncate is true
 */

import styled, { css } from "styled-components";

/**
 * @type {import('styled-components').StyledComponent<'div', any, TextProps>}
 */
export const Text = styled.div`
  font-size: ${(props) => props.fontSize || "16px"};
  line-height: 1.3;

  ${({ truncate, lineClamp }) =>
    truncate &&
    css`
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: ${lineClamp || 1};
      word-break: break-all;
      white-space: ${lineClamp === 1 ? "nowrap" : "normal"};
    `}
`;

export default Text;
